export default ['35rem', '64rem', "80rem", "100rem"]